import * as Axios from 'axios';

import { DocumentItem } from '../providers/Models';

export class DocumentProvider {

  async getDocuments(username: string, sessionKey: string): Promise<DocumentItem[]> {
    let axiosConfig: Axios.AxiosRequestConfig = {
      url: `${process.env.REACT_APP_API_URL}/document?username=${username || ''}&sessionkey=${sessionKey || ''}`,
      method: 'GET',
      headers: { Accept: 'application/json; odata=verbose' }
    }
    const response = await Axios.default(axiosConfig);
    return response.data;
  }
}
